import { type FC } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Icon,
  Typography,
} from '@/ui';

import { SlackishMarkdown } from '@/components/Markdown';

interface SessionSummaryViewProps {
  isExpanded: boolean;
  isLoading: boolean;
  markdown: string | null;
  onExpandedChange: (isExpanded: boolean) => void;
  title?: string;
}

export const SessionSummaryView: FC<SessionSummaryViewProps> = ({
  isExpanded,
  isLoading,
  markdown,
  onExpandedChange,
  title = 'Session Summary',
}) => (
  <Accordion
    className="mt-2"
    expanded={isExpanded}
    onChange={(_, expanded) => onExpandedChange(expanded)}
  >
    <AccordionSummary
      aria-controls="session-summary-content"
      expandIcon={<Icon>expand_more</Icon>}
      id="session-summary-header"
    >
      <Typography className="font-semibold" variant="h6">
        {title}
      </Typography>
      {isLoading && <CircularProgress className="ml-2" size={20} />}
    </AccordionSummary>
    <AccordionDetails>
      {markdown && (
        <div className="max-w-none">
          <SlackishMarkdown text={markdown} />
        </div>
      )}
    </AccordionDetails>
  </Accordion>
);

export default SessionSummaryView;
